const Reviews = () => {
    return (
        <section className="reviews">
            <h2>Customer Reviews</h2>
            <div className="review-grid">
                <div className="review-card">
                    <div className="review-image-name">
                        <img src="/img/review/04.jpg" alt="Customer" />
                        <strong>- Anjali S.</strong>
                    </div>
                    <div className="review-content">
                        <p>Great service! Technician arrived on time and fixed my RO quickly. Highly recommended!</p>
                        ⭐⭐⭐⭐⭐
                    </div>
                </div>
                <div className="review-card">
                    <div className="review-image-name">
                        <img src="/img/review/02.jpg" alt="Customer" />
                        <strong>- Vikas R.</strong>
                    </div>
                    <div className="review-content">
                        <p>Fast and affordable. Very professional team. Thanks for the quick repair!</p>
                        ⭐⭐⭐⭐⭐
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Reviews;